import React from 'react'
import { getComponentById } from '@r/component/component-selectors'
import { brand } from '@r/app-selectors'
import connect from '@h/connect-redux'
import { FsCore } from '@t/fs-core'
import { Button, Trustpilot as TrustpilotAtom, TrustpilotData } from '../../../atoms'

interface Link {
  link: string
  text: string
}

interface PrimaryBillboardProps {
  trustpilotData: TrustpilotData | undefined
  name: string
  jsonBody: {
    title: string
    button: {
      text: string
      link: string
      href: string
    }
    links: Link[]
  }
  showHeader: boolean
  brand: 'money' | 'uswitch'
}

const Billboard = ({ name, jsonBody, trustpilotData, brand }: PrimaryBillboardProps) => {
  const cols: Link[][] = [[], [], []]
  for (let i = 0; i < jsonBody.links.length; i++) {
    cols[i % 3].push(jsonBody.links[i])
  }

  const [col1, col2, col3] = cols.map((items) =>
    items.map((item) => (
      <a href={item.link} className='billboard__links-col'>
        {item.text}
      </a>
    )),
  )

  return (
    <div className='Card Card__modal billboard' id={name}>
      <h2 className='billboard__heading'>{jsonBody.title}</h2>
      {trustpilotData && (
        <TrustpilotAtom trustpilotData={trustpilotData} brand={brand}></TrustpilotAtom>
      )}
      <div className='billboard__links-container'>
        <div className='billboard__links-row'>{col1}</div>
        <div className='billboard__links-row'>{col2}</div>
        <div className='billboard__links-row'>{col3}</div>
      </div>
      <div className='billboard__button'>
        <Button href={jsonBody.button.href}>{jsonBody.button.text}</Button>
      </div>
    </div>
  )
}

export default connect((state: FsCore.State, props: any) => {
  const { sys } = props

  return {
    trustpilotData: getComponentById(state, sys.id)?.trustpilotData,
    brand: brand(state),
  }
})(Billboard)
